import { getGatedIdacBackendUrl } from '../utilities/env';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PageTitle from '../components/PageTitle';
import { useLocation } from 'react-router-dom';

import EmailSent from '../components/EmailSent';
import ButtonLink from '../components/ButtonLink';
import { Flag } from '../types';
import { addFlag } from '../actions/flag-actions';
import messages from './ReverifyEmailSentPage.messages';
import WhiteboxPage from '../components/WhiteboxPage';
import {
  useAnalyticsClient,
  usePageViewedEvent,
} from '../utilities/analytics/analytics-web-client';
import { useAppDispatch, useAppSelector } from '../stores/redux.store';
import Heading from '@atlaskit/heading';
const pageId = 'reverifyEmailSentScreen';

export const ReverifyEmailSentPage = () => {
  const email = useAppSelector(state => state.user.email);
  const dispatch = useAppDispatch();

  const location = useLocation();
  const { formatMessage } = useIntl();
  const analyticsClient = useAnalyticsClient();

  usePageViewedEvent(pageId);

  const addSuccessFlag = () => {
    const flag: Flag = {
      type: 'success',
      title: messages.reverifyEmailFlagSuccessTitle,
      description: messages.reverifyEmailFlagSuccessDesc,
    };
    dispatch(addFlag(flag.type, flag.title, flag.description));
  };

  const addErrorFlag = () => {
    const flag: Flag = {
      type: 'error',
      title: messages.reverifyEmailFlagErrorTitle,
      description: messages.reverifyEmailFlagErrorDesc,
    };
    dispatch(addFlag(flag.type, flag.title, flag.description));
  };

  const handleResendVerificationEmail = () => {
    analyticsClient.buttonClickedEvent(pageId, 'resendReverificationEmail');
    const path = getGatedIdacBackendUrl(`/rest/resend-email${location.search}`);
    return fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        if (response.status === 204) {
          addSuccessFlag();
        } else {
          addErrorFlag();
        }
      })
      .catch(() => {
        addErrorFlag();
      });
  };

  const header = () => (
    <Heading as="h1" size="small">
      <FormattedMessage
        id="reverify.email.title"
        defaultMessage="Check your inbox to verify your email"
      />
    </Heading>
  );

  const whiteboxFooter = () => {
    return (
      <ButtonLink
        id="send-validation-submit"
        spacing="none"
        className="link-color-override"
        onClick={handleResendVerificationEmail}>
        <FormattedMessage
          id="verify.email.resend.reverification.link"
          defaultMessage="Resend verification link"
        />
      </ButtonLink>
    );
  };

  return (
    <WhiteboxPage
      // @ts-ignore no id
      id="reverify-email-sent-page"
      pageId={pageId}
      header={header()}
      whiteboxFooter={whiteboxFooter()}>
      <PageTitle title={formatMessage(messages.headTitle)} />
      <EmailSent
        email={email}
        message={
          <FormattedMessage
            id="reverify.email.sent.verification.link"
            tagName="p"
            defaultMessage="We sent a verification link to:"
            description="Telling user that a verification link has been sent. This message is followed by the user's email address on the next line."
          />
        }
      />
    </WhiteboxPage>
  );
};

export default ReverifyEmailSentPage;
